<template>
  <div class="body">
  <!--<div v-show="loading" id="overlay">-->
    <!--<img id="waitIcon" src="../assets/images/waitIcon.gif" alt="Lütfen Bekleyiniz" style="position:absolute; top: 40%; left: 45%;">-->
  <!--</div>-->
    <Loading :active.sync="isLoading"
             :is-full-page="isFullPage"></Loading>
<!--    <b-modal ref="myModalRef" hide-footer title="Dikkat!">-->
<!--      <div class="d-block text-center">-->
<!--        <h3>Bitirmediğiniz bir sınav mevcut. </h3>-->
<!--        <p>Değerli öğrencimiz, devam etme özelliği tahmin edebileceğiniz gibi ÖSYM tarafından yapılan Elektronik YDS 'de bulunmamaktadır. Sınavınıza devam etmek ister misiniz?</p>-->
<!--      </div>-->
<!--      <b-btn class="mt-3" variant="outline-danger" block @click="sinavBaslat(cozulensinavid,false)">Önceki Sınava Devam Et</b-btn>-->
<!--      <b-btn class="mt-3" variant="outline-danger" block @click="sinavBaslat(cozulensinavid,true)">Yeni Sınava Başla</b-btn>-->
<!--   </b-modal>-->
    <b-modal ref="myModalSinavBitir" hide-footer title="Dikkat!">
      <div class="d-block text-center">
        <div class="container">
          <h3>Uyarı: Sınavı sonlandırdıktan sonra sınava devam edemezsiniz.</h3>
          <h3>Uyarı: Sınavı sonlandırsanız dahi sınav başladıktan sonraki ilk 135 dakika sınav salonunundan ayrılamazsınız.</h3>
        </div>
      </div>
      <b-btn class="mt-3" variant="outline-danger" block @click="sinaviBitir(false)">Sınavı Bitir</b-btn>
      <b-btn class="mt-3" variant="outline-danger" block @click="hideModalSinaviBitir">Vazgeç</b-btn>
    </b-modal>
  <div class="container">
    <div class="header">
      <div class="nav-icons">
<!--        <div aria-hidden="true" class="nav-button">-->
<!--          <a @click="showModalSinavDurumu"  style="cursor: pointer">-->
<!--            <img src="../assets/images/clock-grey.png"><span>ANLIK DURUM</span>-->
<!--          </a>-->
<!--        </div>-->
        <div aria-hidden="true" class="nav-button">
          <a style="cursor: pointer"  @click="showOnizlemeModal" id="gozdenGecirA">
            <img src="../assets/images/magnifier-grey.png"><span>GÖZDEN GEÇİR</span>
          </a>
        </div>
        <div aria-hidden="true" class="nav-button">
          <button style="cursor: pointer" @click="sinaviBitir(false)" type="button">
            <img src="../assets/images/check-grey.png"><span>SINAVI TAMAMLA</span>
          </button>
        </div>
      </div>
<!--      <div aria-hidden="false" class="info-panel">-->
<!--&lt;!&ndash;        <div id="top">&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="left-part">&ndash;&gt;-->
<!--&lt;!&ndash;            <div>Kalan Süre</div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="right-part">&ndash;&gt;-->
<!--&lt;!&ndash;            <div>Aday Bilgileri</div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--        <div id="middle">-->
<!--          <div class="left-part">-->
<!--&lt;!&ndash;            <countdown :time="kdadika  * 60 * 1000" @end="sinaviBitir(false)">&ndash;&gt;-->
<!--&lt;!&ndash;              <template slot-scope="props">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="time-info"><span id="seansSureSpan">{{props.hours}}<span style="font-size: 15px">:{{props.minutes}}</span><span style="font-size: 15px">:{{ props.seconds}}</span></span></div>&ndash;&gt;-->
<!--&lt;!&ndash;                &lt;!&ndash;Time Remaining：{{ props.days }} days, {{ props.hours }} hours, {{ props.minutes }} minutes, {{ props.seconds }} seconds.&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              </template>&ndash;&gt;-->
<!--&lt;!&ndash;            </countdown>&ndash;&gt;-->
<!--            &lt;!&ndash;<vue-countdown-timer :start-time="baslangicZamani"  :end-time="bitisZamani" :end-text="'Seans Bitti'" :interval="1000" @end_callback="sinaviBitir(true)">&ndash;&gt;-->
<!--              &lt;!&ndash;<template slot="countdown" slot-scope="scope">&ndash;&gt;-->
<!--                &lt;!&ndash;<div class="time-info"><span id="seansSureSpan">{{scope.props.hours}}<span style="font-size: 15px">:{{scope.props.minutes}}</span><span style="font-size: 15px">:{{scope.props.seconds}}</span></span></div>&ndash;&gt;-->
<!--              &lt;!&ndash;</template></vue-countdown-timer>&ndash;&gt;-->
<!--            &lt;!&ndash;<div class="time-info"><span id="seansSureSpan">{{kalansaat}}<span style="font-size: 15px">:{{kalandakika}}</span></span></div>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="right-part">-->
<!--            <div>{{user.name}}</div>-->
<!--            <div>{{user.surname}}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div aria-hidden="true" id="bottom">-->
<!--          <div class="left-part">-->
<!--            &lt;!&ndash;<div><a id="changeTimeVisibility" href="#">Süreyi Gizle</a></div>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="right-part">-->
<!--            &lt;!&ndash;<button id="adayBilgiGoruntuleBtn" type="button" data-toggle="modal" data-target="#TumBilgiModal">&ndash;&gt;-->
<!--              &lt;!&ndash;Tüm Bilgilerimi Görüntüle&ndash;&gt;-->
<!--            &lt;!&ndash;</button>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div>
      <div class="container" id="wrapper">
        <b-card style="height:65vh;overflow: auto" bg-variant="white" text-variant="black" :header="SoruNo"  class="text-center">
          <input id="tekrarBakHidden" name="soru.tekrarBak" type="hidden" value="">
          <input id="soruId" name="soruId" type="hidden" :value="aktifSoru._id">
          <p class="yonerge">{{aktifSoru.UstBaslik || '...'}}</p>
          <div class="soru-ifadesi">
            <p class="question"></p><p @mouseup="textrenklendir2" @contextmenu="rengigerial2" v-html="aktifSoru.Soru"></p><p></p>
          </div>
          <div class="secenekler" v-if="aktifSoru.Cevaplar">
            <div class="answerBox" aria-checked="false">
              <div  @contextmenu="toggleEliminated($event,0)"  class="secenek-baslik">
                <input  type="radio" name="isaretlenenSecenek"  class="answer-radio left" value="0" v-model="cevapSecenek" >
                <label class="unselectable" >A</label>
              </div>
              <div  v-bind:class="{secenek: true, eliminated:eliminated[0]}" ><p @mouseup="textrenklendir2" @contextmenu="rengigerial2"  v-html="aktifSoru.Cevaplar[0]"></p></div>
            </div>
            <div  class="answerBox" aria-checked="false">
              <div  @contextmenu="toggleEliminated($event,1)" class="secenek-baslik">
                <input type="radio" name="isaretlenenSecenek" class="answer-radio left" value="1" v-model="cevapSecenek">
                <label class="unselectable">B</label>
              </div>
              <div v-bind:class="{secenek: true, eliminated:eliminated[1]}" ><p @mouseup="textrenklendir2" @contextmenu="rengigerial2"  v-html="aktifSoru.Cevaplar[1]"><br></p></div>
            </div>
            <div  class="answerBox" aria-checked="false">
              <div @contextmenu="toggleEliminated($event,2)" class="secenek-baslik">
                <input type="radio" name="isaretlenenSecenek" class="answer-radio left" value="2" v-model="cevapSecenek">
                <label>C</label>
              </div>
              <div  v-bind:class="{secenek: true, eliminated:eliminated[2]}" ><p @mouseup="textrenklendir2" @contextmenu="rengigerial2"  v-html="aktifSoru.Cevaplar[2]"><br></p></div>
            </div>
            <div  class="answerBox" aria-checked="false">
              <div @contextmenu="toggleEliminated($event,3)"  class="secenek-baslik">
                <input type="radio" name="isaretlenenSecenek" class="answer-radio left" value="3" v-model="cevapSecenek">
                <label >D</label>
              </div>
              <div v-bind:class="{secenek: true, eliminated:eliminated[3]}" ><p @mouseup="textrenklendir2" @contextmenu="rengigerial2"  v-html="aktifSoru.Cevaplar[3]"></p></div>
            </div>
            <div class="answerBox" aria-checked="false">
              <div  @contextmenu="toggleEliminated($event,4)" class="secenek-baslik">
                <input type="radio" name="isaretlenenSecenek" class="answer-radio left" value="4" v-model="cevapSecenek">
                <label>E</label>
              </div>
              <div  v-bind:class="{secenek: true, eliminated:eliminated[4]}"><p @mouseup="textrenklendir2" @contextmenu="rengigerial2"  v-html="aktifSoru.Cevaplar[4]"></p></div>
            </div>
          </div>
          <div class="container">
            <div class="col-xs-6 left text-center" aria-hidden="true">
              <a style="cursor:pointer" variant="link" @click="oncekiSoru">
                <img src="../assets/images/arrow-left-big.png">Önceki Soru</a>
            </div>
            <div class="col-xs-6 right text-center" aria-hidden="true" >
              <a style="cursor:pointer" variant="link" @click="this.sonrakiSoru">
                <img src="../assets/images/arrow-right-big.png">Sonraki Soru</a>
            </div>
          </div>
        </b-card>
<!--        <div class="sidebar left">-->
<!--&lt;!&ndash;          <div aria-live="assertive" class="question-number" id="soruNumarasiDiv">&ndash;&gt;-->
<!--&lt;!&ndash;            {{aktifSoru.SoruNo}}&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div aria-hidden="true" data-content="Tekrar bakmak için işaret bırakabilirsiniz." class="star" >&ndash;&gt;-->
<!--&lt;!&ndash;            <input type="checkbox" @click="tekrarBak" v-model="geriDonulecekSoru">&ndash;&gt;-->
<!--&lt;!&ndash;            <span></span>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--          <div aria-hidden="true" class="question-nav">-->
<!--            <a style="cursor:pointer" variant="link" @click="oncekiSoru">-->
<!--              <img src="../assets/images/arrow-left-big.png">Önceki Soru</a>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="sidebar right">-->
<!--          <div aria-hidden="true" class="question-nav">-->
<!--            <a style="cursor:pointer" variant="link" @click="this.sonrakiSoru">-->
<!--              <img src="../assets/images/arrow-right-big.png">Sonraki Soru</a>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="page-info">
      </div>
    </div>
  </div>
<!--  <div id="pageFooterDiv" class="footer">-->
<!--    <div class="middle uyari">-->
<!--      <div class="date right text-right">-->
<!--        &lt;!&ndash;05 Aralık 2018&ndash;&gt;-->
<!--      </div>-->
<!--      <div class="middle" aria-hidden="true">-->
<!--        <div class="nav-button">-->
<!--          &lt;!&ndash;<button id="decreaseFont" data-content="Fontu Küçült">&ndash;&gt;-->
<!--            &lt;!&ndash;<img src="../assets/images/textSmaller.png">&ndash;&gt;-->
<!--          &lt;!&ndash;</button>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="nav-button">-->
<!--          &lt;!&ndash;<span id="fontSize" style="color: #ffffff; vertical-align: middle;">18 px</span>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="nav-button">-->
<!--          &lt;!&ndash;<button id="increaseFont" data-content="Fontu Büyüt">&ndash;&gt;-->
<!--            &lt;!&ndash;<img src="../assets/images/textBigger.png">&ndash;&gt;-->
<!--          &lt;!&ndash;</button>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <div role="dialog" tabindex="-1" class="modalcustom modal hide fade in" style="display: none;">
    <div class="modal-header">
      <button class="close" type="button">Kapat<img src="/public/kalitte/Resources/Images/close-blue.png"></button>
      <h3 id="H2">Bilgilerim</h3>
    </div>
    <div class="modal-body">
      <div class="modal-seperator-blue"></div>
      <div class="modal-seperator-black"></div>
      <div class="infoForm">
        <form class="form-horizontal well form-approve">
          <div class="photo">
            <img id="adayBasvuruFoto" alt="" style="width: 65px; height: 90px">
          </div>
          <div class="control-group">
            <label class="control-label">Ad Soyad</label>

            <div class="controls">
              <label>Misafir&nbsp;Aday</label>
            </div>
          </div>
          <div class="control-group">
            <label class="control-label">T.C. Kimlik No</label>

            <div class="controls">
              <label>25891951088</label>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-footer">
    </div>
  </div>
  <modal name="sinavDurumuModal" transition="nice-modal-fade" :min-width="1200"  :min-height="600" :pivot-y="0.5" :adaptive="true" :scrollable="true"  width="60%" height="auto">
      <div class="modal-header">
      <h3 id="myModalLabel">Anlık Sınav Durumu</h3>
      <button  @click="hideModalSinavDurumu"  class="close" type="button">Kapat<img src="../assets/images/close-blue.png"></button>
    </div>
      <div class="modal-body">
        <div class="modal-seperator-blue"></div>
        <table class="modal-content">
          <tbody><tr class="modal-title-black">
            <td>Test Adı</td>
            <td>Kalan Soru</td>
            <td>Cevaplanmış Soru</td>
            <td>Toplam Soru</td>
          </tr>
          <tr class="modal-result">
            <td>{{sinav.denemeAdi}}</td>
            <td>{{kalanSoru}}</td>
            <td id="anlikDurumCevaplananSoru-İngilizce">{{sorular.length - kalanSoru }}</td>
            <td id="anlikDurumToplamSoru-İngilizce">{{sorular.length}}</td>
          </tr>
          <tr class="modal-title-black">
            <td>Geçen Süre</td>
            <td>Kalan Süre</td>
            <td>Sınav Süresi</td>
            <td>1 Soru İçin Harcanan Ortalama Süre</td>
          </tr>
          <tr class="modal-result">
            <td id="anlikDurumGecenSure">{{seansGecenSure}}</td>
            <td id="anlikDurumKalanSure">{{seansKalanSure}} </td>
            <td id="anlikDurumToplamSure">{{sinav.sinavkacdakika}} dakika</td>
            <td id="anlikDurumOrtalamaSure">{{seansGecenSureSoruOrani}} saniye</td>
          </tr>
          <tr class="modal-title-black">
            <td colspan="2">Başlama</td>
            <td colspan="2">Bitiş</td>
          </tr>
          <tr class="modal-result">
            <td colspan="2">{{baslangicZamani}}</td>
            <td colspan="2">{{bitisZamani}}</td>
          </tr>
          </tbody></table>
      </div>
    </modal>
    <modal name="onizleme" transition="nice-modal-fade" :min-width="1200"  :min-height="600" :pivot-y="0.5" :adaptive="true" :scrollable="true"  width="60%" height="auto">
      <div  class="modal-header">
        <strong>Gözden Geçir</strong>
        <button  @click="hideOnizlemeModal" aria-hidden="true" data-dismiss="modal" class="close" type="button">Kapat<img src="../assets/images/close-blue.png"></button>
      </div>
      <div  class="modal-body">
        <div class="modal-seperator-blue"></div>
        <div class="modal-seperator-black"></div>
        <div class="numberBox-container">
          <!--<ul class="nav nav-tabs">-->
            <!--&lt;!&ndash;<li class="active"><a data-toggle="tab" href="#tab1">İngilizce</a></li>&ndash;&gt;-->
          <!--</ul>-->
          <div class="tab-content">
            <div id="tab1" class="tab-pane in active">
              <div class="number-title-black" align="center">Lütfen görüntülemek istediğiniz soruya tıklayınız.</div>
              <div id="testSorulari" class="modal-table">
                <b-button @click="soruGetir(soru)" @mouseover="setOnIzlemeSoru(soru)" v-bind:class='{numberbox:true, numberboxStar: soru.yenidenBakilacak === true &&  (!soru.cevap)  , numberboxEmpty: (!soru.cevap && (soru.yenidenBakilacak === false || !soru.yenidenBakilacak ) )  ,  numberboxStarDot: (soru.yenidenBakilacak && (soru.cevap) ) ,numberboxDot: ( (soru.cevap )  && !soru.yenidenBakilacak)}' v-for="soru in sorular"   v-bind:key="soru._id" >{{soru.SoruNo}}</b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="previewDiv-container">
          <table class="number-title-black-table">
            <tbody><tr>
              <td class="number-title-black">Önizleme Paneli
              </td>
            </tr>
            </tbody></table>
          <div id="previewDiv">
            <p class="question"></p> <p>{{onIzlemeSoru.Soru}}</p>
            <div class="answer-container">
              <div class="answerBox" aria-checked="false">
                <div class="secenek-baslik">
                  <input id="-83882497" type="radio" class="answer-radio left" value="A">

                  <label class="unselectable" for="-83882497">A</label>
                </div>
                <div class="secenek " id="secenekA"><p>{{onIzlemeSoru.Cevaplar[0]}}</p></div>
              </div>
              <div class="answerBox" aria-checked="false">
                <div class="secenek-baslik">
                  <input id="-1096399837" type="radio" class="answer-radio left" value="B">

                  <label class="unselectable" for="-1096399837">B</label>
                </div>
                <div class="secenek " id="secenekB"><p>{{onIzlemeSoru.Cevaplar[1]}}</p></div>
              </div>
              <div class="answerBox" aria-checked="false">
                <div class="secenek-baslik">
                  <input id="-754722142" type="radio" class="answer-radio left" value="C">

                  <label class="unselectable" for="-754722142">C</label>
                </div>
                <div class="secenek " id="secenekC"><p>{{onIzlemeSoru.Cevaplar[2]}}</p></div>
              </div>
              <div class="answerBox" aria-checked="false">
                <div class="secenek-baslik">
                  <input id="223729500" type="radio" class="answer-radio left" value="D">

                  <label class="unselectable" for="223729500">D</label>
                </div>
                <div class="secenek " id="secenekD"><p>{{onIzlemeSoru.Cevaplar[3]}}</p></div>
              </div>
              <div class="answerBox" aria-checked="false">
                <div class="secenek-baslik">
                  <input id="1348843408" type="radio" class="answer-radio left" value="E">
                  <label class="unselectable" for="1348843408">E</label>
                </div>
                <div class="secenek " id="secenekE"><p>{{onIzlemeSoru.Cevaplar[4]}}</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {sinavOlusturveyaOlaniGetir, sendAnswer, setEndQuiz, postSetAddFavorites} from '../utility/ajaxMethods'
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import 'moment-duration-format'
import Loading from 'vue-loading-overlay'
export default {
  name: 'Sinav',
  data () {
    return {
      sinavid: -1,
      cevapSecenek: null,
      cozulensinavid: null,
      seansBaslamaKalanSure: null,
      source: null,
      isSeansBitti: null,
      timeSpan: null,
      seansBasladiFunctionExists: null,
      seansBaslamaZamani: null,
      seansBitisZamani: null,
      timeInterval: null,
      loading: false,
      saat: '00',
      kalandakika: '00',
      kalansaat: '00',
      hata: '',
      geriDonulecekSoru: false,
      now: new Date(),
      onIzlemeSoru: {Cevaplar: []},
      isLoading: false,
      isFullPage: true,
      eliminated: [],
      cozulensinav: null,
      analizsinavi: null,
      analizSorulari: [],
      analizCevaplari: []
    }
  },
  computed: {
    ...mapState([
      'user', 'sinav', 'sorular', 'cevaplar', 'baslangicZamani', 'bitisZamani', 'kdadika'
    ]),
    ...mapGetters([
      'aktifSoru'
    ]),
    SoruNo: function () {
      return 'Soru :' + this.aktifSoru.SoruNo
    },
    kalanSoru: function () {
      return (this.sorular.length - this.cevaplar.length) || 0
    },
    seansGecenSure: function () {
      let now = moment(this.now)
      return moment.duration(now.diff(moment(this.baslangicZamani))).format('HH:mm:ss')
    },
    seansKalanSure: function () {
      let now = moment(this.now)
      return moment.duration(moment(this.bitisZamani).diff(now)).format('HH:mm:ss')
    },
    seansGecenSureSoruOrani: function () {
      let now = moment(this.now)
      let saniye = moment.duration(now.diff(moment(this.baslangicZamani))).format('ss').replace(',', '')
      return (Number(saniye) / this.cevaplar.length).toFixed(2)
    }
  },
  watch: {
    aktifSoru: function (val) {
      this.cevapSecenek = val.cevap
      this.geriDonulecekSoru = val.yenidenBakilacak
    }
  },
  created () {
    window.addEventListener('beforeunload', this.kullanicicikismesaji)
    this.sinavid = this.$route.params.sinavid
  },
  async mounted () {
    const token = this.user.token
    const sid = this.sinavid
    // const cozulensinavid = this.cozulensinavid
    const sinav = await sinavOlusturveyaOlaniGetir(token, sid, this.$serviceAddress)
    this.cozulensinav = sinav.cozulenSinav
    this.cozulensinavid = sinav.cozulenSinav._id
    this.analizsinavi = sinav.analizsinavi
    this.analizSorulari = sinav.analizSorulari
    this.analizCevaplari = sinav.analizCevaplari
    this.sinavBaslat()
    window.setInterval(() => {
      this.now = new Date()
    }, 1000)
  },
  components: {
    Loading
  },
  methods: {
    ...mapActions([
      'startQuiz_ACTION',
      'setError_ACTION',
      'setSonrakiSoru_ACTION',
      'setOncekiSoru_ACTION',
      'addCevap_ACTION',
      'setSoru_ACTION',
      'addRemoveFAVORI_ACTION'
    ]),
    toggleEliminated (e, secenek) {
      e.preventDefault()
      this.eliminated[secenek] = !this.eliminated[secenek]
    },
    textrenklendir (e, txt) {
      if (!e.button) {
        if (document.getSelection) {
          let target = e.target || e.srcElement
          if (target.matches('.cc')) {
            return
          }
          let sel = document.getSelection()
          switch (txt) {
            case 'soru' :
              this.aktifSoru.Soru = this.aktifSoru.Soru.replace(sel, '<span class="cc" eskitext="' + sel + '" style="background-color: yellow">' + sel + '</span>')
              break
            default :
              this.aktifSoru.Cevaplar[txt] = this.aktifSoru.Cevaplar[txt].replace(sel, '<span class="cc" eskitext="' + sel + '" style="background-color: yellow">' + sel + '</span>')
          }
        }
      }
      // let target = e.target || e.srcElement
      // let text = target.textContent || target.innerText
      // alert(text)
    },
    textrenklendir2 (e) {
      if (!e.button) {
        this.highlight(e, 'yellow')
      }
    },
    rengigerial (e, txt) {
      e.preventDefault()
      // console.log(e.button)
      if (e.button === 2) {
        let target = e.target || e.srcElement
        // let text = target.textContent || target.innerText
        if (target.matches('.cc')) {
          switch (txt) {
            case 'soru' :
              this.aktifSoru.Soru = this.aktifSoru.Soru.replace('<span class="cc" eskitext="' + target.getAttribute('eskitext') + '" style="background-color: yellow">' + target.getAttribute('eskitext') + '</span>', target.getAttribute('eskitext'))
              break
            default :
              this.aktifSoru.Cevaplar[txt] = this.aktifSoru.Cevaplar[txt].replace('<span class="cc" eskitext="' + target.getAttribute('eskitext') + '" style="background-color: yellow">' + target.getAttribute('eskitext') + '</span>', target.getAttribute('eskitext'))
              // txt = txt.replace('<span class="cc" eskitext="' + target.getAttribute('eskitext') + '" style="background-color: yellow">' + target.getAttribute('eskitext') + '</span>', target.getAttribute('eskitext'))
          }
        }
      }
    },
    rengigerial2 (e) {
      if (e.button === 2) {
        if (e.target.tagName.toLowerCase() === 'span') {
          window.getSelection().selectAllChildren(e.target)
          this.highlight(e, 'white')
          e.preventDefault()
          // var tmp = document.createElement("DIV");
          // tmp.innerHTML = html;
          // return tmp.textContent || tmp.innerText || "";
        }
      }
    },
    makeEditableAndHighlight (colour) {
      var range
      var sel = window.getSelection()
      if (sel.rangeCount && sel.getRangeAt) {
        range = sel.getRangeAt(0)
      }
      document.designMode = 'on'
      if (range) {
        sel.removeAllRanges()
        sel.addRange(range)
      }
      // Use HiliteColor since some browsers apply BackColor to the whole block
      if (!document.execCommand('HiliteColor', false, colour)) {
        document.execCommand('BackColor', false, colour)
      }
      document.designMode = 'off'
      this.secimiTemizle()
    },
    highlight (e, colour) {
      if (!colour) {
        colour = 'yellow'
      }
      var range
      if (window.getSelection) {
        // IE9 and non-IE
        try {
          if (!document.execCommand('BackColor', false, colour)) {
            this.makeEditableAndHighlight(colour)
          }
        } catch (ex) {
          this.makeEditableAndHighlight(colour)
        }
      } else if (document.selection && document.selection.createRange) {
        // IE <= 8 case
        range = document.selection.createRange()
        range.execCommand('BackColor', false, colour)
      }
    },
    secimiTemizle () {
      if (window.getSelection) {
        if (window.getSelection().empty) {
          window.getSelection().empty()
        } else if (window.getSelection().removeAllRanges) {
          window.getSelection().removeAllRanges()
        }
      } else if (document.selection) {
        document.selection.empty()
      }
    },
    al () {
      alert('can')
    },
    kullanicicikismesaji (event) {
      if (this.cevapSecenek !== null) {
        this.soruCevapla()
      }
      event.preventDefault()
      event.returnValue = ''
    },
    // showModal () {
    //   this.$refs.myModalRef.show()
    // },
    // hideModal () {
    //   this.$refs.myModalRef.hide()
    // },
    showModalSinavDurumu () {
      this.$modal.show('sinavDurumuModal')
    },
    hideModalSinavDurumu () {
      this.$modal.hide('sinavDurumuModal')
    },
    showModalSinaviBitir () {
      this.$refs.myModalSinavBitir.show()
    },
    hideModalSinaviBitir () {
      this.$refs.myModalSinavBitir.hide()
    },
    showOnizlemeModal () {
      this.soruCevapla()
      this.$modal.show('onizleme')
    },
    hideOnizlemeModal () {
      this.$modal.hide('onizleme')
    },
    setOnIzlemeSoru (soru) {
      this.onIzlemeSoru = soru
    },
    setLoading () {
      this.isLoading = true
    },
    hideLoading () {
      this.isLoading = false
    },
    async tekrarBak () {
      // console.log('tekrarBak123')
      await postSetAddFavorites(this.user.token, this.cozulensinavid, this.aktifSoru._id, !this.geriDonulecekSoru, this.$serviceAddress)
      this.addRemoveFAVORI_ACTION({eklesil: this.geriDonulecekSoru, soru: this.aktifSoru})
    },
    async oncekiSoru () {
      this.eliminated = []
      this.setLoading()
      await this.soruCevapla()
      this.setOncekiSoru_ACTION()
      this.hideLoading()
    },
    async sonrakiSoru () {
      this.eliminated = []
      this.setLoading()
      await this.soruCevapla()
      this.setSonrakiSoru_ACTION()
      this.hideLoading()
    },
    async soruGetir (soruno) {
      this.setLoading()
      await this.soruCevapla()
      this.setSoru_ACTION(Number(soruno.SoruNo))
      this.hideOnizlemeModal()
      this.hideLoading()
      // this.cevapSecenek = this.aktifCevap || null
    },
    async sinavBaslat () {
      // if (yenidenbasla === true) {
      //   setEndQuiz(this.user.token, cozulensinavid, this.$serviceAddress)
      //   cozulensinavid = null
      //   this.hideModal()
      // }
      // if (cozulensinavid) {
      //   this.hideModal()
      // }
      this.setLoading()
      // const sinavbaslangic = await startNewQuiz(this.user.token, this.sinavid, cozulensinavid, this.$serviceAddress)
      this.startQuiz_ACTION({deneme: this.cozulensinav, sinav: this.analizsinavi, sorular: this.analizSorulari, cevaplar: this.analizCevaplari, kalandakika: 0})
      // this.$refs.myModalRef.show()
      // if (sinavbaslangic.err == null) {
      //   this.startQuiz_ACTION({deneme: sinavbaslangic.deneme, sinav: sinavbaslangic.sinav, sorular: sinavbaslangic.sorular, cevaplar: sinavbaslangic.cevaplar, kalandakika: sinavbaslangic.kalandakika})
      // } else {
      //   this.setError_ACTION('Sınav başlatılırken hata. Lütfen yeniden giriş yapmayı deneyin')
      //   this.$router.replace({name: 'Sinav'})
      // }
      this.hideLoading()
    },
    async soruCevapla () {
      if (this.cevapSecenek) {
        return new Promise(async (resolve, reject) => {
          const token = this.user.token
          const sid = this.sinavid
          let cevap = await sendAnswer(token, sid, this.aktifSoru._id, this.cevapSecenek, this.cozulensinavid, this.$serviceAddress)
          this.addCevap_ACTION(cevap.cevap)
          resolve()
        })
      }
    },
    async sinaviBitir (kullaniciistegimi) {
      await this.soruCevapla()
      if (kullaniciistegimi === true) {
        this.showModalSinaviBitir()
      } else {
        this.hideModalSinaviBitir()
        try {
          await setEndQuiz(this.user.token, this.cozulensinavid, this.$serviceAddress)
        } catch (e) {
          console.log(e)
        }

        this.$router.replace({name: 'SinavOzeti', params: { sinavid: this.cozulensinavid }})
      }
    }
  }
}
</script>

<style scoped>

  body {
    background: #ffffff;
    font-family: Charter, 'Bitstream Charter', Georgia, serif;
  }
  #overlay {
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: none;
  }
  #clausetest4, #isaretlenmemisClausetest4
  {
    color:blue;
  }
  span p
  {
    display: inherit;
  }
  .soru-ifadesi
  {
    font-weight: bold;
  }
  .soru-ifadesi ol
  {
    font-weight: normal;
    padding-left: 40px;
  }
  .hiddenLink
  {
    pposition:absolute;
    left:-10000px;
    top:auto;
    width:1px;
    height:1px;
    overflow:hidden;
    margin-bottom: -1px;

  }
  .detay-photo img
  {
    width: 150px;
    height: 208px;
    margin: 10px 0;
  }

  .eliminated
  {
    /*color: #d3d3d3;*/
    /*text-decoration: line-through;*/
    opacity: 0.5;
  }
  .engelliMuafWaterMark{
    position: absolute;
    z-index: 0;
    display: block;
    color: red;
    transform: rotate(295deg);
    -webkit-transform: rotate(295deg);
    font-size: 65px;
    margin-top: 100px;
    opacity: 0.5;
    /*left: 0;*/
    bottom: 100px;
    margin-left: 100px;
    transform-origin: 0% 100%;
    -webkit-transform-origin: 0% 100%;
    font-weight: normal !important;
  }
  .bosluk
  {
    color: blue;
  }
  .sari
  {
    background-color: yellow;
  }
  .unselectable {
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .langer{
    margin-right: 10px;
    margin-top: 2px;
    direction: rtl;
    width: 65px;
    background-color: inherit;
    font-weight: bold;
    color: #ffffff;
  }

  .langer option{
    background-color: #808080;
  }
  .aday-sure-button
  {
    padding: 0 10px 0 0;
    color: #807F7F;
    font-weight: bold;
    float: left;
    width: 30%;
  }
  .aday-bilgi
  {
    font-weight: bold;
    float: left;
    padding-left: 15px;
  }
  .aday-bilgi-row {
    border: solid!important;
    border-color: grey!important;
    /*border-radius: .25rem!important;*/
    border-top-left-radius: .35rem!important;
    border-top-right-radius: .35rem!important;
    border-bottom-left-radius: .35rem!important;
    border-bottom-right-radius: .35rem!important;
    min-width: 400px!important;
    max-height: 200px!important;
    /*margin-left:10% !important;*/
    padding-top: 20px;
    padding-bottom:20px;
    padding-left: 5px;
    padding-right:5px;
  }
  /*sonArananAdayDiv {*/
  /*position: relative;*/
  /*}*/
  /*sonArananAdayDiv:after {*/
  /*content: "";*/
  /*background: black;*/
  /*position: absolute;*/
  /*bottom:0;*/
  /*left:0;*/
  /*height:50%;*/
  /*width: 1px;*/
  /*}*/
  .aday-sure-button a img
  {
    width: 25%;
    height: 25%;
    vertical-align: bottom;
    color: #807F7F;
    font-weight: bold;
    text-align: right;
  }
  .aday-sure-button a p
  {
    padding: 0 10px 0 0;
    color: #807F7F;
    font-weight: bold;
    text-align: left;
  }
  .bss-row
  {
    margin-left: 25px !important;
  }
  .bssTab a
  {
    font-size: 20px !important;
  }
  .bssFormSubmit
  {
    margin-left: 30px;
    float: left;
    padding-top: 20px;
  }
  .bssFormSubmit input
  {
    height: 40px;
    margin: 5px;
  }
  .bssMessageBox
  {
    margin: 10px;
  }
  .bssInputGroup
  {
    float: left;
  }
  .bssFormLabel
  {
    color: red;
  }
  .bssStat
  {
    height: 350px!important
  }
  .bssStatTable{
    height: 300px!important;
    width: 96.4%!important;
  }
  .bssStatTable tr {
    width: 100%;
    display: inline-table;
    table-layout: fixed;
  }
  .bssStatTable tbody {
    overflow-y: auto!important;
    overflow-x: hidden!important;
    position: absolute; height: 300px!important;
    width: 95%!important;
  }
  .bssStatTableTh{
    background-color: rgba(138, 132, 148, 0.76)!important;
  }
  body {
    background: #fff;
    padding: 0; margin: 0;
  }
  #holder {
    width: 100%;
  }

  #holder > div {
    clear: both;
    padding: 2%;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
    float: left;
    width: 96%;
  }
  label {
    display: inline;
  }
  .regular-checkbox {
    display: none;
  }
  .regular-checkbox + label {
    background-color: #fafafa;
    border: 1px solid #cacece;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05);
    padding: 9px;
    border-radius: 3px;
    display: inline-block;
    position: relative;
  }
  .regular-checkbox + label:active, .regular-checkbox:checked + label:active {
    box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px 1px 3px rgba(0,0,0,0.1);
  }
  .regular-checkbox:checked + label {
    background-color: #e9ecee;
    border: 1px solid #adb8c0;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05), inset 15px 10px -12px rgba(255,255,255,0.1);
    color: #99a1a7;
  }
  .regular-checkbox:checked + label:after {
    content: '\2714';
    font-size: 14px;
    position: absolute;
    top: 0px;
    left: 3px;
    color: #99a1a7;
  }
  .big-checkbox + label {
    padding: 18px;
  }
  .big-checkbox:checked + label:after {
    font-size: 28px;
    left: 6px;
  }
  .tag {
    font-family: Arial, sans-serif;
    width: 200px;
    position: relative;
    top: 5px;
    font-weight: bold;
    text-transform: uppercase;
    display: block;
    float: left;
  }
  .radio-1 {
    width: 193px;
  }
  .button-holder {
    float: left;
  }
  /* RADIO */
  .regular-radio {
    display: none;
  }
  .regular-radio + label {
    -webkit-appearance: none;
    background-color: #fafafa;
    border: 1px solid #cacece;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05);
    padding: 9px;
    border-radius: 50px;
    display: inline-block;
    position: relative;
  }
  .regular-radio:checked + label:after {
    content: ' ';
    width: 12px;
    height: 12px;
    border-radius: 50px;
    position: absolute;
    top: 3px;
    background: #99a1a7;
    box-shadow: inset 0px 0px 10px rgba(0,0,0,0.3);
    text-shadow: 0px;
    left: 3px;
    font-size: 32px;
  }
  .regular-radio:checked + label {
    background-color: #e9ecee;
    color: #99a1a7;
    border: 1px solid #adb8c0;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05), inset 15px 10px -12px rgba(255,255,255,0.1), inset 0px 0px 10px rgba(0,0,0,0.1);
  }
  .regular-radio + label:active, .regular-radio:checked + label:active {
    box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px 1px 3px rgba(0,0,0,0.1);
  }
  .big-radio + label {
    padding: 16px;
  }
  .big-radio:checked + label:after {
    width: 24px;
    height: 24px;
    left: 4px;
    top: 4px;
  }
  /* ------- IGNORE */
  #header {
    width: 100%;
    margin: 0px auto;
  }
  #header #center {
    text-align: center;
  }
  #header h1 span {
    color: #000;
    display: block;
    font-size: 50px;
  }
  #header p {
    font-family: 'Georgia', serif;
  }
  #header h1 {
    color: #892dbf;
    font: bold 40px 'Bree Serif', serif;
  }
  #travel {
    padding: 10px;
    background: rgba(0,0,0,0.6);
    border-bottom: 2px solid rgba(0,0,0,0.2);
    font-variant: normal;
    text-decoration: none;
    margin-bottom: 20px;
  }
  #travel a {
    font-family: 'Georgia', serif;
    text-decoration: none;
    border-bottom: 1px solid #f9f9f9;
    color: #f9f9f9;
  }
  @media (min-width: 1200px)
  {
    .header-text
    {
      width: 1050px !important;
    }

    .content-koklu
    {
      width: 482px !important;
    }
  }
  .body
  {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    overflow: hidden;
    height: 93%;
    font-size: 18px;
    line-height: 22px;
    font-family: 'Segoe UI';
    background-color: #F2F2F2;
  }
  .textSelectable
  {
    -webkit-touch-callout: text;
    -webkit-user-select: text;
    -khtml-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }
  a
  {
    text-decoration: none !important;
  }
  .left
  {
    float: left !important;
  }
  .right
  {
    float: right !important;
  }
  .middle
  {
    display: table;
    margin: 0 auto;
  }
  .header-text
  {
    width: 960px;
  }
  .page-title
  {
    height: 32px;
    font-family: 'Segoe UI', Arial;
    font-size: 18px;
    background-color: #333333;
    color: #FFFFFF;
    font-weight: bold;
    line-height: 32px;
    padding-left: 10px;
  }
  .danger
  {
    background-color: #C1272D !important;
  }
  .header
  {
    height: 128px;
    background-color: #F2F2F2;
    padding: 0 0 0 64px;
    position: relative;
    text-align: center;
  }
  .nav-icons
  {
    float: left;
    margin-top: 36px;
  }
  .nav-button
  {
    padding: 0 15px 0 0;
    color: #807F7F;
    font-weight: bold;
    float: left;
  }
  .nav-icons div span
  {
    display: inline-block;
    width: 5em;
    vertical-align: middle;
    color: #807F7F;
    font-weight: bold;
  }
  .nav-icons div img
  {
    padding: 0 2px 0 0;
  }
  .nav-button button
  {
    border: 0 none;
    background: none repeat scroll 0 0 transparent;
  }
  .nav-button a
  {
    line-height: 20px;
    font-size: 14px;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  }
  .nav-icons div span.green
  {
    color: #8CC63F;
  }
  .nav-icons div span.red
  {
    color: #EE423B;
  }
  .info-panel
  {
    height: 128px;
    width: 256px;
    float: right;
    margin-right: 64px;
  }
  #hide-clock
  {
    margin-left: 3px !important;
    margin-bottom: 2px !important;
  }
  .info-title
  {
    background-color: #333333;
    color: #FFFFFF;
    height: 16px;
    font-weight: normal;
    font-size: 14px;
    width: 100%;
    line-height: 20px;
  }
  .info-panel .right-part
  {
    height: 100%;
    line-height: 14px;
    float: right;
    width: 144px;
  }
  .info-panel .left-part
  {
    height: 100%;
    line-height: 14px;
    float: left;
    width: 112px;
  }
  .info-panel div div div
  {
    margin: 0 auto;
    display: table;
  }
  .info-panel #top
  {
    height: 16px;
    width: 256px;
    font-size: 15px;
    background-color: #333333;
    color: #FFFFFF;
  }
  .info-panel #top div
  {
    line-height: 14px !important;

  }
  .info-panel #middle
  {
    height: 96px;
    margin-top: -5px;
  }

  .info-panel #middle div div
  {
    margin-top: 12px;
  }
  .info-panel #middle .left-part
  {
    background-color: #8CC63F;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 24px;
  }
  .info-panel #middle .right-part
  {
    font-size: 18px;
    line-height: 10px;
  }
  .info-panel #bottom
  {
    height: 16px;
    width: 256px;
    font-size: 12px;
  }
  .info-panel #bottom .left-part
  {
    background-color: #8CC63F;
  }
  .info-panel #bottom .right-part
  {
    color: #00ADEE;
  }
  .sidebar
  {
    position: relative;
    top: 0;
    left: auto;
    width: 64px;
    background-color: #F2F2F2;
    height: 45vh;
  }
  .sidebar-center
  {
    width: 16px !important;
  }
  .content
  {
    /*overflow: hidden;*/
    /*min-height: 80vh;*/
    background-color: #FFFFFF;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    padding: 0px 15px 15px 50px;
    position: relative;
    overflow-x: hidden;
    height: 100%;
  }
  .content-koklu
  {
    overflow: auto;
    background-color: #FFFFFF;
    width: 367px;
    height: 610px;
    padding: 15px;
  }
  .yonerge, .kok-ifade
  {
    border:1px solid;
    padding: 1px;
    padding-left: 5px;
    font-weight: bold;
  }
  .alert .close {
    position: relative;
    top: 0px;
    right: 0px;
    line-height: 20px;
    font-size: 30px;
  }
  .container-fluid
  {
    min-height: 640px;
    padding: 0 !important;
  }
  .sidebar .question-nav
  {
    position: absolute;
    top: 50%;
  }
  .page-nav button
  {
    display: table;
    margin: 0 auto;
  }
  .sidebar div a
  {
    display: inline-block;
    text-align: center;
    font-weight: bold;
    font-size: 0.7vw;
    color: #CCCCCC;
  }
  .page-info
  {
    height: 30px;
    background-color: #F2F2F2;
  }
  .page-info div
  {
    height: 100%;
    margin: 0 auto;
    display: table;
    line-height: 44px;
    color: #818181;
    font-size: 18px;
    font-weight: bold;
  }
  .footer
  {
    height: 27px;
    background-color: #333333;
    padding-top: 5px;
  }
  .footer .date
  {
    height: 100%;
    color: #FFFFFF;
    font-size: 16px;
  }
  .uyari
  {
    width: 1050px;
  }
  .uyari .left
  {
    color: #FFFFFF;
  }
  .logo
  {
    width: 208px;
    height: 125px;
    float: left;
  }
  .help a
  {
    color: #807F7F;
    font-weight: bold;
  }
  .exam-info
  {
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
  }
  .form-approve
  {
    width: 360px;
    margin: 10px auto 0;
  }
  .control-label
  {
    font-weight: bold !important;
  }
  .form-horizontal .control-group:after
  {
    clear: none !important;
  }
  .photo
  {
    display: table;
    margin: 0 auto;
  }
  /*input, textarea, .uneditable-input
  {
      width: 90px !important;
  }*/
  input[type="text"]
  {
    width: 90px !important;
  }

  input[type="checkbox"]
  {
    line-height: normal;
    margin: 0px !important;
  }

  .controls label
  {
    padding-top: 5px;
  }

  .form-button-container
  {
    display: table;
    margin: 0 auto;
  }

  .question
  {
    font-size: 18px;
    line-height: 30px;
  }

  .question-number
  {
    color: #888888;
    font-size: 28px;
    font-weight: bold;
    display: table;
    margin: 0 auto;
    padding: 22px 0;
  }

  .modal
  {
    max-width: 2060px;
    width: 2060px;
    margin: 0;
  }
  .modal-dialog{
    max-width: 1200px;
    width: 1200px;
  }
  .modal-seperator-blue
  {
    width: 100%;
    background-color: #00ADEE;
    height: 3px;
  }

  .modal-seperator-black
  {
    width: 100%;
    background-color: #333333;
    height: 30px;
  }

  .modal-title-black
  {
    background-color: #333333;
    height: 30px;
    font-size: 16px;
    color: #FFFFFF;
  }

  .modal-title-blue
  {
    background-color: #00ADEE;
    height: 30px;
    font-size: 18px;
    color: #FFFFFF;
  }

  .modal-title-grey
  {
    background-color: #E6E6E6;
    height: 30px;
    font-size: 16px;
    color: #333333;
  }

  .modal-body
  {
    padding: 0 !important;
    /*max-height: 420px !important;*/
    height: auto !important;
    max-height: none !important;
    overflow-y: hidden;
  }

  .modal-header
  {
    padding: 0 10px 0 10px !important;
    height: 50px;
  }

  .modal-header h3
  {
    font-size: 21px;
    font-weight: bold;
    color: #00ADEE;
    line-height: 50px;
  }

  .modal-header .close
  {
    font-size: 21px;
    color: #00ADEE;
    margin-top: 1px;
    opacity: 1;
  }

  .modal-result
  {
    /*width: 100%;*/
    height: 40px;
    font-size: 18px;
    color: #006837;
    font-weight: bold;
  }

  .modal-content
  {
    /*min-width: 1200px;*/
    width: 100%;
  }

  .modal-content tr td
  {
    text-align: center;
    width: 190px;
  }

  .modal-footer
  {
    text-align: left !important;
    font-weight: bold;
    font-size: 16px;
    padding: 6px 6px 6px 6px;
    margin-top: 10px;
  }

  .modal-table
  {
    background-color: #F2F2F2;
    margin: 0 auto;
    text-align: center;
    width: 500px;
    display: table;
  }

  .numberbox
  {
    float: left;
    background-repeat: no-repeat;
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 2px;
    /*padding: 2px,2px,2px,6px;*/
    height: 50px;
    width: 48px;
    font-size: 20px;
    font-weight: bold;
    border: none;
    background: none repeat scroll 0 0 transparent;
    color: #808080;
  }

  button[readonly="readonly"].numberbox{
    opacity: 0.3;
  }

  .number-title-black
  {
    margin: 0 auto !important;
    font-size: 15px;
    color: black;
    line-height: 30px !important;
    font-size: large;
    font-weight: bold;
  }

  .number-title-black-table
  {
    margin: 0 auto;
  }

  .question-group
  {
    margin: 0 auto;
  }

  .question-group tr td
  {
    color: #00ADEE;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    padding-right: 10px;
  }

  .question-group tr td label
  {
    color: #00ADEE;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    padding-right: 10px;
    margin-bottom: 0px;
  }

  .main-table-user
  {
    width: auto;
    margin: 0 auto;
    /*height: 100%;*/
    overflow: hidden;
    overflow-x: hidden;
    clear: both;
  }

  .table-user
  {
    background-color: #fafafa;
    width: 61px;
    height: 145px;
    margin: 1px;
    float: left;
    border: 2px solid #E1E1E1;
  }

  .aday-ad, .aday-tc
  {
    font-size: 7pt !important;
    line-height: 7pt;
    margin: 2px 0 !important;
    padding: 0;
  }

  .tableuser
  {
    width: 75px;
    height: 100px;
    margin: 0 auto;
    display: table;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  }

  .usertext
  {
    text-align: center;
    margin-bottom: 1px;
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 5px;
  }

  .usertext-red
  {
    color: red;
  }

  .usertext-green
  {
    color: #4E9007;
  }

  .usertext-grey
  {
    color: #807F7F;
  }

  .usertext-blue
  {
    color: #3160c8;
  }

  /*.basic-numpad*/
  /*{*/
  /*background-image: url(../assets/images/basic-numpad.png);*/
  /*background-repeat: no-repeat;*/
  /*height: 25px;*/
  /*width: 24px;*/
  /*text-align: center;*/
  /*color: #808080;*/
  /*margin: 3px;*/
  /*font-size: 8pt;*/
  /*line-height: 18pt;*/
  /*float: left;*/
  /*}*/

  .form-horizontal .control-group
  {
    margin-bottom: 6px !important;
  }

  .star
  {
    height: 35px;
    width: 37px;
    margin: auto;
  }

  .star span:after
  {
    background-image: url(../assets/images/star-enabled.png);
  }

  .star span
  {
    background-image: url(../assets/images/star-disabled.png);
    height: 35px;
    width: 37px;
    margin: 0 auto;
    display: table;
  }

  .star input
  {
    position: absolute;
    height: 35px;
    margin: 0 auto;
    display: table;
    /*hide the radio button*/
    filter: alpha(opacity=0);
    -moz-opacity: 0;
    -khtml-opacity: 0;
    opacity: 0;
    cursor: pointer;
    width: 37px !important;
  }

  .star input[type="checkbox"] + span
  { /*the span element that immediately follow the radio button */
    background-image: url(../assets/images/star-disabled.png);
  }

  .star input[type="checkbox"] + span:after
  {
    background-image: url(../assets/images/star-enabled.png);
  }

  .star input[type="checkbox"]:checked + span
  {
    background-image: url(../assets/images/star-enabled.png);
  }

  .answerBox
  {
    display: table-row;
    /*margin: 16px 0;*/
  }

  .secenek
  {
    display: table-cell;
    vertical-align: middle;
    padding-top: 10px;
    text-align: left !important;
  }

  .secenek p
  {
    text-align: left !important;
  }

  .secenek-baslik
  {
    display: table-cell;
    width: 50px;
    vertical-align: middle;
  }

  .secenek-baslik input + label
  {
    background-image: url(../assets/images/dot-grey.png);
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 4px auto;
  }

  .secenek-baslik input:checked + label
  {
    background-image: url(../assets/images/tick.png);
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 4px auto;
  }

  .secenekler
  {
    display: table;
    width: 100%;
    margin-top: 20px;
    font-weight: 500;
    font-family: "Segoe UI Semibold";
  }
  .answerBox input
  {
    position: absolute;
    height: 38px;
    width: 38px;
    display: table;
    filter: alpha(opacity=0);
    opacity: 0;
    cursor: pointer;
  }

  .answerBox input + label>span
  {
    background-image: url(../assets/images/dot-grey.png);
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 3px 5px 5px 10px;
  }

  .answerBox input:checked + label>span
  {
    background-image: url(../assets/images/tick.png);
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 3px 5px 5px 10px;
  }

  .answerText
  {
    margin-top: 3px;
    font-size: 18px;
    text-align: left;
    line-height: 30px;
    padding-left: 53px;
  }

  .answerCheck
  {
    /*background-image: url(../assets/images/tick-green.png);*/
    background-repeat: no-repeat;
    height: 50px;
    width: 50px;
    float: left;
  }

  .Tick
  {
    background-image: url(../assets/images/tick.png);
    width: 36px;
    height: 36px;
    background-repeat: no-repeat;
    visibility: hidden;
    opacity: 0.9;
    margin-left: 10px;
    margin-top: 2px;
  }

  .answer-container
  {
    margin: 50px 0px 0px 5px;
  }

  .buttonAnswer
  {
    background: none repeat scroll 0 0 transparent;
    border: 0 none;
    cursor: pointer;
    height: 50px;
    width: 50px;
    float: left;
    opacity: 1;
  }

  #bottom .right-part button
  {
    font-size: 12px;
    border: none;
    color: #00ADEE;
    padding: 0 !important;
    line-height: 12px;
  }

  #TumBilgiModal
  {
    width: 550px !important;
  }

  #TumBilgiModal modal-body infoForm
  {
    width: 520px !important;
  }

  .btn-gozdengecir
  {
    height: 100px;
    width: 250px;
    font-size: 18px;
    text-wrap: normal;
    line-height: 24px;
    margin-left: 24px;
  }

  .numberBox-container
  {
    width: 620px;
    float: left;
    display: table;
    margin-left: 0px;
  }

  .questiongroup-container
  {
    width: 590px;
    float: left;
    display: block;
    position: absolute;
    bottom: 20px;
  }

  .previewDiv-container
  {
    width: 416px;
    overflow: hidden;
    max-heightc: 600px;
    float: right;
    margin-right: 20px;
    margin-bottom: 20px;
    display: block;
    padding:2px;
  }

  #previewDiv
  {
    border: 1px solid #CCCCCC;
    height: 600px;
    overflow: hidden;
    padding: 10px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    margin-top: 3px;
  }

  #previewDiv .answer-container
  {
    margin: 20px 0 0 50px;
  }

  #previewDiv .answerBox input + span
  {
    background-image: url(../assets/images/dot-grey.png);
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 3px 5px 5px 10px;
  }

  #previewDiv .answerBox input:checked + span
  {
    /*background-image: url(../assets/images/tick.png);*/
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 3px 5px 5px 10px;
  }

  #previewDiv .answerText
  {
    margin: 0 !important;
    font-size: 14px;
    line-height: 22px;
    padding-left:36px;
  }

  #previewDiv .question
  {
    font-size: 14px;
  }

  .nav-button button
  {
    outline: none;
  }

  .seans-summary {
    margin: 15px 0;
    font-size: 8pt;
    height: 30px;
  }

  .seans-summary .btn-group
  {
    float: left;
  }

  .seans-summary .update-time-info
  {
    float: right;
    margin-right: 10px;
    line-height: 28px;
    outline: none;
  }

  .summary-info {
    display: table-cell;
    border-right: solid 1px #808080;
    text-align: center;
  }

  .summary-label {
    display: inline;
    color: #808080;
  }

  .summary-info-value {
    display: inline;
    font-weight: bold;
    color: #4E9007;
  }

  .hidden-card
  {
    display: none;
  }
  .modal.show .modal-dialog {
    width: 1300px;
    max-width: 1300px;
  }
  @media (min-width: 1200px)
  {
    .header-text
    {
      width: 1050px !important;
    }

    .content-koklu
    {
      width: 482px !important;
    }
  }

  body
  {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    overflow: hidden;
    height: 100%;

    font-size: 18px;
    line-height: 22px;
    font-family: 'Segoe UI';
    background-color: #F2F2F2;
  }

  .textSelectable
  {
    -webkit-touch-callout: text;
    -webkit-user-select: text;
    -khtml-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  a
  {
    text-decoration: none !important;
  }

  .left
  {
    float: left !important;
  }

  .right
  {
    float: right !important;
  }

  .middle
  {
    display: table;
    margin: 0 auto;
  }

  .header-text
  {
    width: 960px;
  }

  .page-title
  {
    height: 32px;
    font-family: 'Segoe UI', Arial;
    font-size: 18px;
    background-color: #333333;
    color: #FFFFFF;
    font-weight: bold;
    line-height: 32px;
    padding-left: 10px;
  }

  .danger
  {
    background-color: #C1272D !important;
  }

  .header
  {
    height: 128px;
    background-color: #F2F2F2;
    padding: 0 0 0 64px;
    position: relative;
    text-align: center;
  }

  .nav-icons
  {
    float: left;
    margin-top: 36px;
  }

  .nav-button
  {
    padding: 0 15px 0 0;
    color: #807F7F;
    font-weight: bold;
    float: left;
  }

  .nav-icons div span
  {
    display: inline-block;
    width: 5em;
    vertical-align: middle;
    color: #807F7F;
    font-weight: bold;
  }

  .nav-icons div img
  {
    padding: 0 2px 0 0;
  }

  .nav-button button
  {
    border: 0 none;
    background: none repeat scroll 0 0 transparent;
  }
  .nav-button a
  {
    line-height: 20px;
    font-size: 14px;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  }

  .nav-icons div span.green
  {
    color: #8CC63F;
  }

  .nav-icons div span.red
  {
    color: #EE423B;
  }

  .info-panel
  {
    height: 128px;
    width: 256px;
    float: right;
    margin-right: 64px;
  }

  #hide-clock
  {
    margin-left: 3px !important;
    margin-bottom: 2px !important;
  }

  .info-title
  {
    background-color: #333333;
    color: #FFFFFF;
    height: 16px;
    font-weight: normal;
    font-size: 14px;
    width: 100%;
    line-height: 20px;
  }

  .info-panel .right-part
  {
    height: 100%;
    line-height: 14px;
    float: right;
    width: 144px;
  }

  .info-panel .left-part
  {
    height: 100%;
    line-height: 14px;
    float: left;
    width: 112px;
  }

  .info-panel div div div
  {
    margin: 0 auto;
    display: table;
  }

  .info-panel #top
  {
    height: 16px;
    width: 256px;
    font-size: 15px;
    background-color: #333333;
    color: #FFFFFF;
  }

  .info-panel #top div
  {
    line-height: 14px !important;

  }
  .info-panel #middle
  {
    height: 96px;
    margin-top: -5px;
  }

  .info-panel #middle div div
  {
    margin-top: 12px;
  }

  .info-panel #middle .left-part
  {
    background-color: #8CC63F;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 24px;
  }

  .info-panel #middle .right-part
  {
    font-size: 18px;
    line-height: 10px;
  }

  .info-panel #bottom
  {
    height: 16px;
    width: 256px;
    font-size: 12px;
  }

  .info-panel #bottom .left-part
  {
    background-color: #8CC63F;
  }

  .info-panel #bottom .right-part
  {
    color: #00ADEE;
  }

  /*.sidebar*/
  /*{*/
    /*position: relative;*/
    /*top: 0;*/
    /*left: auto;*/
    /*width: 64px;*/
    /*background-color: #F2F2F2;*/
    /*height: 640px;*/
  /*}*/

  .sidebar-center
  {
    width: 16px !important;
  }

  /*.content*/
  /*{*/
    /*overflow: hidden;*/
    /*min-height: 610px;*/
    /*background-color: #FFFFFF;*/
    /*box-shadow: 0 2px 4px rgba(0,0,0,0.2);*/
    /*padding: 15px;*/
    /*position: relative;*/
    /*overflow-x: hidden;*/
    /*height: 100%;*/
  /*}*/

  /*.content-koklu*/
  /*{*/
    /*overflow: auto;*/
    /*background-color: #FFFFFF;*/
    /*width: 367px;*/
    /*height: 610px;*/
    /*padding: 15px;*/
  /*}*/

  .yonerge, .kok-ifade
  {
    border:1px solid;
    padding: 1px;
    padding-left: 5px;
    font-weight: bold;
  }

  .alert .close {
    position: relative;
    top: 0px;
    right: 0px;
    line-height: 20px;
    font-size: 30px;
  }

  .container-fluid
  {
    min-height: 640px;
    padding: 0 !important;
  }

  .sidebar .question-nav
  {
    position: absolute;
    top: 50%;
  }

  .page-nav button
  {
    display: table;
    margin: 0 auto;
  }

  .sidebar div a
  {
    display: inline-block;
    text-align: center;
    font-weight: bold;
    font-size: 0.7vw;
    color: #CCCCCC;
  }

  .page-info
  {
    height: 30px;
    background-color: #F2F2F2;
  }

  .page-info div
  {
    height: 100%;
    margin: 0 auto;
    display: table;
    line-height: 44px;
    color: #818181;
    font-size: 18px;
    font-weight: bold;
  }

  .footer
  {
    height: 27px;
    background-color: #333333;
    padding-top: 5px;
  }

  .footer .date
  {
    height: 100%;
    color: #FFFFFF;
    font-size: 16px;
  }

  .uyari
  {
    width: 1050px;
  }

  .uyari .left
  {
    color: #FFFFFF;
  }

  .logo
  {
    width: 208px;
    height: 125px;
    float: left;
  }

  .help a
  {
    color: #807F7F;
    font-weight: bold;
  }

  .exam-info
  {
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
  }

  .form-approve
  {
    width: 360px;
    margin: 10px auto 0;
  }

  .control-label
  {
    font-weight: bold !important;
  }

  .form-horizontal .control-group:after
  {
    clear: none !important;
  }

  .photo
  {
    display: table;
    margin: 0 auto;
  }

  /*input, textarea, .uneditable-input
  {
      width: 90px !important;
  }*/

  input[type="text"]
  {
    width: 90px !important;
  }

  input[type="checkbox"]
  {
    line-height: normal;
    margin: 0px !important;
  }

  .controls label
  {
    padding-top: 5px;
  }

  .form-button-container
  {
    display: table;
    margin: 0 auto;
  }

  .question
  {
    font-size: 18px;
    line-height: 30px;
  }

  .question-number
  {
    color: #888888;
    font-size: 28px;
    font-weight: bold;
    display: table;
    margin: 0 auto;
    padding: 22px 0;
  }
  .numberbox
  {
    float: left;
    background-repeat: no-repeat;
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 2px;
    /*padding: 2px,2px,2px,6px;*/
    height: 50px;
    width: 48px;
    font-size: 20px;
    font-weight: bold;
    border: none;
    background: none repeat scroll 0 0 transparent;
    color: #808080;
  }

  button[readonly="readonly"].numberbox{
    opacity: 0.3;
  }

  .numberboxStar
  {
    background-image: url(../assets/images/numbox-star.png);
  }

  .numberboxCheck
  {
    background-image: url(../assets/images/numbox-check.png);
    opacity: 1;
  }

  .numberboxCheckStar
  {
    background-image: url(../assets/images/numbox-check-star.png);
    opacity: 1;
  }

  .numberboxStarDot
  {
    background-image: url(../assets/images/numbox-star-dot.png);
  }

  .numberboxDot
  {
    background-image: url(../assets/images/numbox-dot.png);
  }

  .numberboxEmpty
  {
    background-image: url(../assets/images/numbox-grey.png);
  }

  .numberboxRed
  {
    background-image: url(../assets/images/numbox-red.png);
    color: #CF232A;
  }

  .numberboxYellow
  {
    background-image: url(../assets/images/numbox-yellow.png);
    color: #FAAC17;
  }

  .numberboxBlue
  {
    background-image: url(../assets/images/numbox-blue.png);
    color: #00ADEE;
  }

  .numberboxGrey
  {
    background-image: url(../assets/images/numbox-grey.png);
    color: #808080;
  }

  .numberbox-previous
  {
    background-image: url(../assets/images/previous-page.png);
  }

  .numberbox-next
  {
    background-image: url(../assets/images/next-page.png);
  }

  .number-title-black
  {
    margin: 0 auto !important;
    font-size: 15px;
    color: black;
    line-height: 30px !important;
    font-size: large;
    font-weight: bold;
  }

  .number-title-black-table
  {
    margin: 0 auto;
  }

  .question-group
  {
    margin: 0 auto;
  }

  .question-group tr td
  {
    color: #00ADEE;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    padding-right: 10px;
  }

  .question-group tr td label
  {
    color: #00ADEE;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    padding-right: 10px;
    margin-bottom: 0px;
  }

  .main-table-user
  {
    width: auto;
    margin: 0 auto;
    /*height: 100%;*/
    overflow: hidden;
    overflow-x: hidden;
    clear: both;
  }

  .table-user
  {
    background-color: #fafafa;
    width: 61px;
    height: 145px;
    margin: 1px;
    float: left;
    border: 2px solid #E1E1E1;
  }

  .aday-ad, .aday-tc
  {
    font-size: 7pt !important;
    line-height: 7pt;
    margin: 2px 0 !important;
    padding: 0;
  }

  .tableuser
  {
    width: 75px;
    height: 100px;
    margin: 0 auto;
    display: table;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  }

  .usertext
  {
    text-align: center;
    margin-bottom: 1px;
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 5px;
  }

  .usertext-red
  {
    color: red;
  }

  .usertext-green
  {
    color: #4E9007;
  }

  .usertext-grey
  {
    color: #807F7F;
  }

  .usertext-blue
  {
    color: #3160c8;
  }

  .basic-numpad
  {
    background-image: url(../assets/images/basic-numpad.png);
    background-repeat: no-repeat;
    height: 25px;
    width: 24px;
    text-align: center;
    color: #808080;
    margin: 3px;
    font-size: 8pt;
    line-height: 18pt;
    float: left;
  }

  .form-horizontal .control-group
  {
    margin-bottom: 6px !important;
  }

  .star
  {
    height: 35px;
    width: 37px;
    margin: auto;
  }

  .star span:after
  {
    background-image: url(../assets/images/star-enabled.png);
  }

  .star span
  {
    background-image: url(../assets/images/star-disabled.png);
    height: 35px;
    width: 37px;
    margin: 0 auto;
    display: table;
  }

  .star input
  {
    position: absolute;
    height: 35px;
    margin: 0 auto;
    display: table;
    /*hide the radio button*/
    filter: alpha(opacity=0);
    -moz-opacity: 0;
    -khtml-opacity: 0;
    opacity: 0;
    cursor: pointer;
    width: 37px !important;
  }

  .star input[type="checkbox"] + span
  { /*the span element that immediately follow the radio button */
    background-image: url(../assets/images/star-disabled.png);
  }

  .star input[type="checkbox"] + span:after
  {
    background-image: url(../assets/images/star-enabled.png);
  }

  .star input[type="checkbox"]:checked + span
  {
    background-image: url(../assets/images/star-enabled.png);
  }

  .answerBox
  {
    display: table-row;
    /*margin: 16px 0;*/
  }

  .secenek
  {
    display: table-cell;
    vertical-align: middle;
    padding-top: 10px;
    text-align: left !important;
  }

  .secenek p
  {
    text-align: left !important;
  }

  .secenek-baslik
  {
    display: table-cell;
    width: 50px;
    vertical-align: middle;
  }

  .secenek-baslik input + label
  {
    background-image: url(../assets/images/dot-grey.png);
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 4px auto;
  }

  .secenek-baslik input:checked + label
  {
    background-image: url(../assets/images/tick.png);
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 4px auto;
  }

  .secenekler
  {
    display: table;
    width: 100%;
    margin-top: 20px;
    font-weight: 500;
    font-family: "Segoe UI Semibold";
  }
  .answerBox input
  {
    position: absolute;
    height: 38px;
    width: 38px;
    display: table;
    filter: alpha(opacity=0);
    opacity: 0;
    cursor: pointer;
  }

  .answerBox input + label>span
  {
    background-image: url(../assets/images/dot-grey.png);
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 3px 5px 5px 10px;
  }

  .answerBox input:checked + label>span
  {
    background-image: url(../assets/images/tick.png);
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 3px 5px 5px 10px;
  }

  .answerText
  {
    margin-top: 3px;
    font-size: 18px;
    text-align: left;
    line-height: 30px;
    padding-left: 53px;
  }

  .answerCheck
  {
    /*background-image: url(../assets/images/tick-green.png);*/
    background-repeat: no-repeat;
    height: 50px;
    width: 50px;
    float: left;
  }

  .Tick
  {
    background-image: url(../assets/images/tick.png);
    width: 36px;
    height: 36px;
    background-repeat: no-repeat;
    visibility: hidden;
    opacity: 0.9;
    margin-left: 10px;
    margin-top: 2px;
  }

  .answer-container
  {
    margin: 50px 0px 0px 5px;
  }

  .buttonAnswer
  {
    background: none repeat scroll 0 0 transparent;
    border: 0 none;
    cursor: pointer;
    height: 50px;
    width: 50px;
    float: left;
    opacity: 1;
  }

  #bottom .right-part button
  {
    font-size: 12px;
    border: none;
    color: #00ADEE;
    padding: 0 !important;
    line-height: 12px;
  }

  #TumBilgiModal
  {
    width: 550px !important;
  }

  #TumBilgiModal modal-body infoForm
  {
    width: 520px !important;
  }

  .btn-gozdengecir
  {
    height: 100px;
    width: 250px;
    font-size: 18px;
    text-wrap: normal;
    line-height: 24px;
    margin-left: 24px;
  }

  .numberBox-container
  {
    width: 620px;
    float: left;
    display: table;
    margin-left: 0px;
  }

  .questiongroup-container
  {
    width: 590px;
    float: left;
    display: block;
    position: absolute;
    bottom: 20px;
  }

  .previewDiv-container
  {
    width: 416px;
    overflow: hidden;
    max-heightc: 600px;
    float: right;
    margin-right: 20px;
    margin-bottom: 20px;
    display: block;
    padding:2px;
  }

  #previewDiv
  {
    border: 1px solid #CCCCCC;
    height: 600px;
    overflow: hidden;
    padding: 10px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    margin-top: 3px;
  }

  #previewDiv .answer-container
  {
    margin: 20px 0 0 50px;
  }
  #previewDiv .answerBox input + span
  {
    background-image: url(../assets/images/dot-grey.png);
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 3px 5px 5px 10px;
  }

  #previewDiv .answerBox input:checked + span
  {
    background-image: url(../assets/images/tick.png);
    background-repeat: no-repeat;
    height: 38px;
    width: 38px;
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-align: center;
    line-height: 34px;
    float: left;
    margin: 3px 5px 5px 10px;
  }

  #previewDiv .answerText
  {
    margin: 0 !important;
    font-size: 14px;
    line-height: 22px;
    padding-left:36px;
  }

  #previewDiv .question
  {
    font-size: 14px;
  }

  .nav-button button
  {
    outline: none;
  }

  .seans-summary {
    margin: 15px 0;
    font-size: 8pt;
    height: 30px;
  }

  .seans-summary .btn-group
  {
    float: left;
  }

  .seans-summary .update-time-info
  {
    float: right;
    margin-right: 10px;
    line-height: 28px;
    outline: none;
  }

  .summary-info {
    display: table-cell;
    border-right: solid 1px #808080;
    text-align: center;
  }

  .summary-label {
    display: inline;
    color: #808080;
  }

  .summary-info-value {
    display: inline;
    font-weight: bold;
    color: #4E9007;
  }

  .hidden-card
  {
    display: none;
  }
  @media (min-width: 992px) {
    .modal-lg {
      max-width: 1200px;
    }
  }
  .modal.show .modal-dialog {
    width: 1200px;
  }
  .deneme > .modal-dialog{
    color:green;
  }
  /*.cc{*/
    /*-webkit-touch-callout: none;*/
    /*-webkit-user-select: none;*/
    /*-khtml-user-select: none;*/
    /*-moz-user-select: none;*/
    /*-ms-user-select: none;*/
    /*user-select: none;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/Sinav.vue